/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Experience_NeverInputs */

const en_us2_onboarding_experience_never = /** @type {(inputs: Onboarding_Experience_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Never trained with weights`)
};

const pt_br2_onboarding_experience_never = /** @type {(inputs: Onboarding_Experience_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nunca treinei com pesos`)
};

const es_419_onboarding_experience_never = /** @type {(inputs: Onboarding_Experience_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nunca entrené con pesas`)
};

const pt_pt2_onboarding_experience_never = /** @type {(inputs: Onboarding_Experience_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nunca treinei com pesos`)
};

const fr_fr2_onboarding_experience_never = /** @type {(inputs: Onboarding_Experience_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jamais fait de musculation`)
};

const de_de2_onboarding_experience_never = /** @type {(inputs: Onboarding_Experience_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie mit Gewichten trainiert`)
};

const it_it2_onboarding_experience_never = /** @type {(inputs: Onboarding_Experience_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mai fatto pesi`)
};

/**
* | output |
* | --- |
* | "Never trained with weights" |
*
* @param {Onboarding_Experience_NeverInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_experience_never = /** @type {((inputs?: Onboarding_Experience_NeverInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Experience_NeverInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_experience_never(inputs)
	if (locale === "es-419") return es_419_onboarding_experience_never(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_experience_never(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_experience_never(inputs)
	if (locale === "de-DE") return de_de2_onboarding_experience_never(inputs)
	if (locale === "it-IT") return it_it2_onboarding_experience_never(inputs)
	return en_us2_onboarding_experience_never(inputs)
});
export { onboarding_experience_never as "onboarding.experience.never" }